export default [
  {
    name: "users",
    icon: "mdi-account",
    routes: ["list"],
  },
];
